import { FormEvent } from 'react';
import { UseFormReturnType } from '@mantine/form';
import { Stack, TextInput } from '@mantine/core';
import { OnboardingSignupFormValues } from '../applySubmissionError';
import { WizardShell } from '../components/WizardShell';

type CompanyNameStepProps = {
  form: UseFormReturnType<OnboardingSignupFormValues>;
  direction: 1 | -1;
  currentStepIndex: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
};

export function CompanyNameStep({ form, onBack, onNext }: CompanyNameStepProps) {
  const handleNext = (event?: FormEvent) => {
    event?.preventDefault();
    if (form.validateField('companyName').hasError) return;
    onNext();
  };

  return (
    <WizardShell
      title="What is your company called?"
      onBack={onBack}
      onAction={handleNext}
      actionDisabled={!form.isValid('companyName')}
    >
      <form onSubmit={handleNext}>
        <Stack gap="lg">
          <TextInput
            required
            label="Company name"
            placeholder="e.g. Acme financial planning"
            key={form.key('companyName')}
            {...form.getInputProps('companyName')}
            data-autofocus
          />
        </Stack>
      </form>
    </WizardShell>
  );
}
